export function mustDoActivities(offerId: string | undefined, cartId: string | undefined, orderId: string | undefined, locationId: string | undefined, region: string | undefined) {
  return ['mustDoActivities', offerId, cartId, orderId, locationId, region] as const
}

export const mustDoActivitiesSingle = (locationId: string, region: string | undefined) =>
  ['mustDoActivitiesSingle', locationId, region] as const
